import { useMemo } from 'react';
import { Tooltip } from '@chakra-ui/react';

import { Txt } from '@app/components/common';


export const CommentColumn = ({ text }: { text: string }) => {
  const cutText = useMemo(() => {
    if (!text) {return '';}
    if (text.length > 50) {
      const limit = text.indexOf(' ', 50);
      if (limit !== -1) {
        return text.slice(0, limit) + '...';
      }
      return text.slice(0, 50) + '...';
    }
    return text;
  }, [text]);

  return (
    <Tooltip label={text}>
      <Txt whiteSpace='pre-wrap' >{cutText}</Txt>
    </Tooltip>
  );
};